import { render, staticRenderFns } from "./new_score.vue?vue&type=template&id=c50d20b4&"
import script from "./new_score.vue?vue&type=script&lang=js&"
export * from "./new_score.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports